import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import { AiFillCheckCircle, AiFillCloseCircle } from 'react-icons/ai';
import { BsCheck2Circle, BsXCircleFill } from 'react-icons/bs';
import { FiTag } from 'react-icons/fi';

export const PRODUCT_CONFIG = {
  addToCartDialog: {
    continueShoppingButton: {
      variant: 'default',
    } as ButtonProps,
    addToCartButton: {
      variant: 'accent',
    } as ButtonProps,
  },
  productStock: {
    availableIcon: <AiFillCheckCircle className="h-4 w-4" />,
    unavailableIcon: <AiFillCloseCircle className="h-4 w-4" />,
  },
  availabilityLabel: {
    availableIcon: <BsCheck2Circle className="h-4 w-4" />,
    unavailableIcon: <BsXCircleFill className="h-4 w-4" />,
  },
  productPrice: {
    discountIcon: <FiTag className="h-4 w-4 stroke-[2px]" />,
  },
  notInStockDialog: {
    closeButton: {
      variant: 'default',
    } as ButtonProps,
  },
} as const;
